import { render, staticRenderFns } from "./SubModal.vue?vue&type=template&id=e4200132&"
import script from "./SubModal.vue?vue&type=script&lang=js&"
export * from "./SubModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports